// eslint-disable-next-line import/prefer-default-export
export const WEBVIEW_USER_AGENT = 'react-native-app';
//# sourceMappingURL=user-agent.js.map